import { useEffect, useRef, useState } from 'react';

const ScrollToTop = () => {
  const [showScroll, setShowScroll] = useState(false);
  const footerRef = useRef(null);

  useEffect(() => {
    const checkScrollTop = () => {
      if (!footerRef.current) return;
      
      const footerPosition = footerRef.current.getBoundingClientRect().top;
      const windowHeight = window.innerHeight;
      
      setShowScroll(
        window.pageYOffset > 400 && footerPosition > windowHeight + 100
      );
    };

    window.addEventListener('scroll', checkScrollTop);
    return () => window.removeEventListener('scroll', checkScrollTop);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <div 
      className={`scroll-to-top ${showScroll ? "visible" : "hidden"}`}
      onClick={scrollToTop}
    >
      <i className="arrow up"></i>
    </div>
  );
};

export default ScrollToTop;